import React from "react";
import Button from "../button/button";

const ArrowRight = props => {
	return (
		<Button
			onClick={e => props.onClick(e)}
			className={`btn-gray-sm-icon offers-arrow-right ${props.className}`}
			data-action="arrow-right"
		>
			<i className="icon-arrow-down" />
		</Button>
	);
};

export default ArrowRight;
